export default {"src":"/_next/static/media/laptop.c920420e.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};